import axios from "axios";

function extractArrayFromPayload(payload) {
  // Se vier como string (ex: backend retornando JSON stringificado incorretamente), tenta parsear
  if (typeof payload === "string") {
    try {
      payload = JSON.parse(payload);
    } catch (e) {
      console.error(
        "[extractArrayFromPayload] Erro ao parsear JSON string:",
        e,
      );
      return [];
    }
  }

  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];

  const keys = [
    "data",
    "items",
    "rows",
    "result",
    "results",
    "content",
    "value",
  ];
  for (const key of keys) {
    const candidate = payload[key];
    if (Array.isArray(candidate)) return candidate;
  }

  for (const key of keys) {
    const candidate = payload[key];
    if (candidate && typeof candidate === "object") {
      const nested = extractArrayFromPayload(candidate);
      if (nested.length) return nested;
    }
  }

  return [];
}

function normalizeHistoricoItem(item) {
  return {
    ...item,
    id: item?.id ?? item?.idCandidatura ?? item?.codigo ?? null,
    idVaga: item?.idVaga ?? item?.vagaId ?? null,
    titulo: item?.titulo ?? item?.tituloVaga ?? item?.vagaTitulo ?? "-",
    dataCriacao:
      item?.dataCriacao ??
      item?.dataAplicacao ??
      item?.dtCriacao ??
      item?.createdAt ??
      null,
    status: item?.status ?? item?.situacao ?? item?.codStatus ?? null,
    observacao:
      item?.observacao ??
      item?.area ??
      item?.areaInteresse ??
      item?.motivo ??
      "",
  };
}

const candidaturaInternaStore = {
  namespaced: true,

  state: {
    step: 1,
    escolaridades: [],
    escolaridadeSelecionada: 0,
    candidato: null,

    // NOVO: o que o usuario escolheu no step 2
    tipoSelecao: null, // "VAGA" | "BANCO"
    vagaSelecionada: null, // objeto da vaga (quando tipoSelecao = "VAGA")

    // NOVO: escolhas do banco de talentos (quando tipoSelecao = "BANCO")
    bancoSelecao: {
      unidade: null,
      operadorProducao: null,
      servicosExternos: null,
      manutencao: null,
      outrasAreas: null,
      administrativo: null,
    },

    historicoCandidaturas: [],
    loadingHistorico: false,
  },

  mutations: {
    setStep(state, step) {
      state.step = step;
    },
    setEscolaridades(state, escolaridades) {
      state.escolaridades = escolaridades;
    },
    setSelecionaEscolaridade(state, escol) {
      state.escolaridadeSelecionada = escol;
    },
    setCandidato(state, cand) {
      state.candidato = cand;
    },

    // NOVO
    setTipoSelecao(state, tipo) {
      state.tipoSelecao = tipo; // "VAGA" | "BANCO"
    },
    setVagaSelecionada(state, vaga) {
      state.vagaSelecionada = vaga;
    },
    setBancoSelecao(state, payload) {
      state.bancoSelecao = { ...state.bancoSelecao, ...payload };
    },

    setHistoricoCandidaturas(state, candidaturas) {
      state.historicoCandidaturas = Array.isArray(candidaturas)
        ? candidaturas
        : [];
    },
    setLoadingHistorico(state, loading) {
      state.loadingHistorico = loading;
    },

    // opcional: limpar selecao quando voltar ao step 2
    // resetSelecao(state) {
    //   state.tipoSelecao = null;
    //   state.vagaSelecionada = null;
    //   state.bancoSelecao = {
    //     unidade: null,
    //     operadorProducao: null,
    //     servicosExternos: null,
    //     manutencao: null,
    //     outrasAreas: null,
    //     administrativo: null,
    //   };
    // },
  },

  actions: {
    async carregarHistoricoCandidaturas({ commit }) {
      console.log(
        "[candidaturainterna_store] carregarHistoricoCandidaturas: inicio",
      );
      commit("setLoadingHistorico", true);
      try {
        const url = "/colaborador/candidatura-vagas";
        console.log(
          "[candidaturainterna_store] BaseURL:",
          axios.defaults.baseURL,
        );
        const token = sessionStorage.getItem("userKey");
        console.log(
          "[candidaturainterna_store] Token (4 chars):",
          token ? token.substring(0, 4) : "NULL",
        );
        console.log(
          "[candidaturainterna_store] GET:",
          url,
          "Params: LISTAR-MINHAS-CANDIDATURAS",
        );

        const response = await axios.get(
          "/colaborador/candidatura-vagas?funcao=LISTAR-MINHAS-CANDIDATURAS",
        );

        const payload = response?.data;
        console.log("[candidaturainterna_store] payload bruto:", payload);

        const maybeArray = extractArrayFromPayload(payload);
        console.log(
          "[candidaturainterna_store] itens extraidos:",
          maybeArray.length,
        );
        if (maybeArray.length > 0) {
          console.log(
            "[candidaturainterna_store] item extraido[0]:",
            maybeArray[0],
          );
        }

        const normalized = maybeArray.map(normalizeHistoricoItem);
        console.log(
          "[candidaturainterna_store] itens normalizados:",
          normalized.length,
        );
        if (normalized.length > 0) {
          console.log(
            "[candidaturainterna_store] item normalizado[0]:",
            normalized[0],
          );
        }

        commit("setHistoricoCandidaturas", normalized);
      } catch (error) {
        console.error(
          "[candidaturainterna_store] erro ao carregar historico:",
          error,
        );
        console.error(
          "[candidaturainterna_store] erro.response?.data:",
          error?.response?.data,
        );
        commit("setHistoricoCandidaturas", []);
      } finally {
        commit("setLoadingHistorico", false);
        console.log(
          "[candidaturainterna_store] carregarHistoricoCandidaturas: fim",
        );
      }
    },

    async excluirCandidatura(context, idCandidatura) {
      try {
        const response = await axios.post(
          "/colaborador/candidatura-vagas?funcao=EXCLUIR-MINHA-CANDIDATURA",
          { id: idCandidatura },
        );
        if (response.data.success) {
          return true;
        } else {
          throw new Error(response.data.msg || "Erro ao excluir candidatura");
        }
      } catch (error) {
        console.error("Erro ao excluir candidatura:", error);
        throw error;
      }
    },
  },
  getters: {
    historicoCandidaturas: (state) => state.historicoCandidaturas,
    loadingHistorico: (state) => state.loadingHistorico,
  },
};

export default candidaturaInternaStore;
